"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSnackbar = void 0;
const react_1 = require("react");
const SnackbarContext_1 = require("./SnackbarContext");
const utils_1 = require("../../utils");
function useSnackbar() {
    const { setNotices, setOffset } = (0, SnackbarContext_1.useSnackbarContext)();
    const onClose = (0, react_1.useCallback)((noticeId) => {
        setNotices((prev) => {
            let returnValue = prev;
            // check to see if the notice is still in our existing stack, if so then remove it. Otherwise it was manually closed, so return the existing value.
            if (prev.some(({ id }) => id === noticeId)) {
                returnValue = prev.filter(({ id }) => id !== noticeId);
            }
            // For good measure, reset the snackbarId when notices array is emptied.
            if (returnValue.length === 0) {
                snackbarId = 1;
            }
            return returnValue;
        });
    }, []);
    const triggerNotice = (0, react_1.useCallback)((props) => {
        var _a;
        // Sets `noticeId` to the current value of `snackbarId` and then increments.
        const noticeId = (_a = props.id) !== null && _a !== void 0 ? _a : `beamSnackbar:${snackbarId++}`;
        let maybeTimeout;
        if (!props.persistent) {
            maybeTimeout = window.setTimeout(() => {
                onClose(noticeId);
                // Auto close in 10s
            }, 10000);
        }
        setNotices((prev) => prev.concat({
            ...props,
            id: noticeId,
            onClose: () => {
                // Because we reset the `snackbarId` if the notices array is empty, then we need to call `clearTimeout` to ensure we don't accidentally close the wrong notice
                clearTimeout(maybeTimeout);
                onClose(noticeId);
                (0, utils_1.maybeCall)(props.onClose);
            },
        }));
        return {
            close: () => {
                // Because we reset the `snackbarId` if the notices array is empty, then we need to call `clearTimeout` to ensure we don't accidentally close the wrong notice
                clearTimeout(maybeTimeout);
                onClose(noticeId);
            },
        };
    }, [onClose, setNotices]);
    const closeNotice = (0, react_1.useCallback)((id) => onClose(id), [onClose]);
    const useSnackbarOffset = ({ bottom }) => (0, react_1.useEffect)(() => {
        setOffset({ bottom });
        return () => setOffset({});
    }, [bottom]);
    return { triggerNotice, closeNotice, useSnackbarOffset };
}
exports.useSnackbar = useSnackbar;
let snackbarId = 1;
